var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("content"),(_vm.hasMore)?_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({ callback: _vm.handleScroll, intersection: { rootMargin: '200px' } }),expression:"{ callback: handleScroll, intersection: { rootMargin: '200px' } }"}]}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }